<template>
  <div class="comp-section-item my-2 selected-column">
    <div class="grid-row">
      <!-- Section Name -->
      <div class="grid-name">
        {{ section.name }}
      </div>

      <!-- Remove Button -->
      <a
        class="action-icon remove-icon"
        tabindex="0"
        title="Remove section"
        @click="$emit('remove', section.id)"
      >
        <font-awesome-icon
          icon="times"
          aria-hidden="true"
          class="removeIcon"
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { SectionSimpleDto } from '@/types'

export default Vue.extend({
  name: 'SelectedSectionItem',
  props: {
    section: {
      type: Object as () => SectionSimpleDto,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.removeIcon {
  float: right;
  margin-top: 18px;
  width: 22px;
  height: 22px;
  &:hover {
    cursor: pointer;
  }
}

.remove-icon {
  grid-column: 2;
  line-height: 60px;
}

.selected-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 3px !important;
  max-width: 40%;
}

.comp-section-item {
  background: $brand-white;
  cursor: default;
  border: 1px solid $brand-grey4;

  &:hover {
    border-color: $brand-red;
  }

  .grid-row {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: 60px;
    align-items: center;
  }

  .grid-name {
    line-height: 60px;
    font-size: 13px;
    font-weight: 700;
    color: $brand-red;
    text-transform: uppercase;
    font-family: 'Signa-Light', Sans-Serif;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    user-select: none;
  }

  @media (max-width: $media-md-max) {
    .grid-row {
      display: flex;
    }
  }
}

@media (max-width: $media-sm-max) {
  .selected-column {
    max-width: 100% !important;
  }
}
</style>